"use client"

import { useDestinationValueFormatter } from "@/hooks/use-destination-value-formatter"
import type { ValueMapping } from "@/types/fbo-api"

interface ValueMappingDisplayProps {
  sourceValue: ValueMapping["sourceValue"]
  destinationValue: ValueMapping["destinationValue"]
  codeTableName?: string | null
  codeTableValueType?: number | null
  className?: string
}

export function ValueMappingDisplay({ 
  sourceValue, 
  destinationValue, 
  codeTableName,
  codeTableValueType,
  className = "font-mono bg-background px-2 py-1 rounded"
}: ValueMappingDisplayProps) {
  const { formatDestinationValue } = useDestinationValueFormatter()

  return (
    <div className="flex items-center space-x-2 text-sm">
      <span className={className}>
        {JSON.stringify(sourceValue)}
      </span>
      <span>→</span>
      <span className={className}>
        {formatDestinationValue(destinationValue, codeTableName, codeTableValueType ?? undefined)}
      </span>
    </div>
  )
} 